import { render, staticRenderFns } from "./stripeReturn.vue?vue&type=template&id=46bb6c47&scoped=true"
import script from "./stripeReturn.vue?vue&type=script&lang=js"
export * from "./stripeReturn.vue?vue&type=script&lang=js"
import style0 from "./stripeReturn.vue?vue&type=style&index=0&id=46bb6c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb6c47",
  null
  
)

export default component.exports